var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('inner-table',{ref:"archiveChangeInfo",attrs:{"id":"archiveChangeInfo","listviewurl":'rsgl.archiveChangeInfo.list',"can-edit":_vm.canEdit,"can-delete":_vm.canEdit,"link-prop-name":'archivesId'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }